import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ButtonsModule } from "ngx-bootstrap/buttons";

import { CommonModule } from "@angular/common";

// Datepicker
import { TranslateModule } from "@ngx-translate/core";
import { PipeModule } from "../../../pipes/pipe.module";
import { AreaSelectorComponent } from "./area-selector.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { AreaTreeModule } from "../area-tree/area-tree.module";
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    BsDropdownModule,
    NgSelectModule,
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule,
    AreaTreeModule,
    PipeModule,
  ],
  exports: [AreaSelectorComponent],
  declarations: [AreaSelectorComponent],
})
export class AreaSelectorModule {}
